/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeploymentLogsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetDeploymentLogsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetDeploymentLogsSecurity = {
  option1?: GetDeploymentLogsSecurityOption1 | undefined;
  option2?: GetDeploymentLogsSecurityOption2 | undefined;
};

export type GetDeploymentLogsRequest = {
  /**
   * The ID of the deployment
   */
  deploymentId: string;
  /**
   * The cursor to fetch results from
   */
  cursor?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetDeploymentLogsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetDeploymentLogsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetDeploymentLogsSecurityOption1$Outbound,
  GetDeploymentLogsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getDeploymentLogsSecurityOption1ToJSON(
  getDeploymentLogsSecurityOption1: GetDeploymentLogsSecurityOption1,
): string {
  return JSON.stringify(
    GetDeploymentLogsSecurityOption1$outboundSchema.parse(
      getDeploymentLogsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetDeploymentLogsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetDeploymentLogsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetDeploymentLogsSecurityOption2$Outbound,
  GetDeploymentLogsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDeploymentLogsSecurityOption2ToJSON(
  getDeploymentLogsSecurityOption2: GetDeploymentLogsSecurityOption2,
): string {
  return JSON.stringify(
    GetDeploymentLogsSecurityOption2$outboundSchema.parse(
      getDeploymentLogsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetDeploymentLogsSecurity$Outbound = {
  Option1?: GetDeploymentLogsSecurityOption1$Outbound | undefined;
  Option2?: GetDeploymentLogsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetDeploymentLogsSecurity$outboundSchema: z.ZodMiniType<
  GetDeploymentLogsSecurity$Outbound,
  GetDeploymentLogsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetDeploymentLogsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetDeploymentLogsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getDeploymentLogsSecurityToJSON(
  getDeploymentLogsSecurity: GetDeploymentLogsSecurity,
): string {
  return JSON.stringify(
    GetDeploymentLogsSecurity$outboundSchema.parse(getDeploymentLogsSecurity),
  );
}

/** @internal */
export type GetDeploymentLogsRequest$Outbound = {
  deployment_id: string;
  cursor?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetDeploymentLogsRequest$outboundSchema: z.ZodMiniType<
  GetDeploymentLogsRequest$Outbound,
  GetDeploymentLogsRequest
> = z.pipe(
  z.object({
    deploymentId: z.string(),
    cursor: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getDeploymentLogsRequestToJSON(
  getDeploymentLogsRequest: GetDeploymentLogsRequest,
): string {
  return JSON.stringify(
    GetDeploymentLogsRequest$outboundSchema.parse(getDeploymentLogsRequest),
  );
}
